/* @flow strict */

import * as React from 'react';
import { DefaultContainerContext } from '../../contexts/defaultContainer';
import { SortableElement, sortableHandle } from 'react-sortable-hoc';
import _ from 'lodash';
import Switcher from '../switcher';
import './styles.scss';

type PropsType = {
  data: any,
  tempId: string,
  panelClass?: string,
  hideBody?: boolean
};

export const DragHandle = (): React.Element<'div'> => {
  const Component = sortableHandle((): React.Element<'div'> => {
    return (
      <div style={{ display: 'inline' }}>
        <span className='dragHandle' />
      </div>
    );
  });

  return <Component />;
};

const SortableItem = SortableElement((props: PropsType): React.Element<'div'> => {
  const context = React.useContext(DefaultContainerContext);

  const handleSort = (direction: string) => {
    if (direction === 'up') {
      if (+props.data.index !== 0) {
        props.data.onSortEnd({
          oldIndex: props.data.index,
          newIndex: props.data.index - 1
        });
      }
    }

    if (direction === 'down') {
      if (+props.data.index + 1 !== _.size(props.data.items)) {
        props.data.onSortEnd({
          oldIndex: props.data.index,
          newIndex: props.data.index + 1
        });
      }
    }
  };

  return (
    <div
      className={`sortable-item ${props.panelClass}_${props.id}`}
      data-testid={`sortable-item_${props.panelClass}_${props.id}`}
    >
      <div className={`panel panel-default panel-active ${props.panelClass}`}>
        <div className="panel-heading">
          <div className="panel-title">
            <DragHandle index={props.data.index} />
            {!!props.data.handleSetStatus &&
              <Switcher
                wrapperClassName={'sortable-item-switcher'}
                className='form-switcher-sm pull-left mb0rem'
                id={`Active-ticker-level-${props.id}`}
                index={0}
                checked={props.value.is_active}
                dataTestid={'SortableElement-switcher'}
                onCallback={() => {
                  props.data.handleSetStatus(props.id, !props.value.is_active);
                }}
              />
            }
            <span className='panel-title-text' ref={props.panelTitleRef}>
               {!props.data.withoutTitle &&
                <>
                  {props.data.type === 'questions' ? ` Question ${props.data.index + 1}` : props.value.name}
                </>
               }
            </span>
          </div>
          <div className="panel-actions pull-right">
            <span
              className="panel-action"
              onClick={() => {
                if (props.data.type && (props.data.type === 'questions' || props.data.type === 'donations')) {
                  props.data.handleRemoveTicket(props.data.index, props.id);
                } else if (!props.value.can_delete && !props.isClone) {
                    context.handleShowSystemDialog(true, {
                      systemDialogType: 'error',
                      systemDialogTitle: 'Oops!',
                      systemDialogContent: 'We can\'t delete ticket types that have already been sold.'
                    });
                  } else {
                    props.data.handleRemoveTicket(props.tempId, props.id);
                  }
              }}
              data-testid={'SortableElement-remove'}
            >
              <i className="icon icon-trash" />
            </span>

            <span
              className={`panel-action ${+props.data.index === 0 ? 'disabled' : ''}`}
              onClick={() => {
                handleSort('up');
              }}
              data-testid={'SortableElement-up'}
            >
              <i className="icon icon-chevron-up" />
            </span>

            <span
              className={`panel-action ${+props.data.index === (_.size(props.data.items) - 1) ? 'disabled' : ''}`}
              onClick={() => {
                handleSort('down');
              }}
              data-testid={'SortableElement-down'}
            >
              <i className="icon icon-chevron-down" />
            </span>
          </div>
        </div>

         {props.children && _.get(props, 'value.is_active', true) ?
          <div className="panel-body">
            {props.children}
          </div> : null
         }
      </div>
    </div>
  );
});

export default SortableItem;
